import React, { useState, useEffect, useContext } from "react";
import { Container, Col, Row } from "react-bootstrap";
import Accordion from "react-bootstrap/Accordion";
import URLstateContext from "../../../../provider/CommonContext";
import renderHTML from 'react-render-html';
import { Vortex } from 'react-loader-spinner'
import animation from '../../../../images/jm-animation.gif';
import {
    GetPostMethodData,
    DecryptAESdata,
} from "../../../../provider/ServiceProvider";
import './FinQKYC.css';

import KYCIndividual from '../../../../PDF/Partner Offline Empanelment/KYC-Individual.pdf'
import KYCNonIndividual from "../../../../PDF/Partner Offline Empanelment/KYC-Non-Individual.pdf";
import Finpdf from "../../../../PDF/AMFI-Investor-Awareness-Presentation.pdf"

function FinQKYC() {
    const [data, setData] = useState(false);
    const { BaseURL } = useContext(URLstateContext);
    const [loadingshow, setloadingshow] = useState(false);



    useEffect(() => {
        setloadingshow(true);
        GetPostMethodData(BaseURL + "GetFAQ", {
            faqcatid: "3",
        }).then((data) => {
            if (data.data != null && data.data.length > 0) {
                setData(DecryptAESdata(data.data));
                setloadingshow(false);
            }
        });
    }, [BaseURL]);

    return (
        <>
            <Container>
                <Row>
                    <Col sm={12}>
                        <div className="kyc-para-container">
                            <p>
                                Looking to invest your hard-earned money wisely? Mutual funds are a good option! They offer diversified investment opportunities, just like other avenues. However, it's essential to know that all investments come with risks. To make the right choice, you should compare the risks and potential returns, taking taxes into account. Don't worry if this sounds complicated – you can always seek advice from experts like a Mutual Fund Distributor/Financial advisor before making investments. We have included an investor education presentation to assist you in understanding the mechanics of mutual funds, empowering you to make informed and prudent investment decisions.
                            </p>
                            <div className='iap-download'>
                                {/* <a target="_blank" href={Finpdf}> Scheduled for Investor Awareness Program </a> */}
                                  <a target="_blank" href={Finpdf}> AMFI - Investor Awareness Presentation </a>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>

            {/* <Container>
                <Row>
                    <Col sm={12}>
                        <div className="kyc-para-container">
                            <h3>
                                KYC ( Know Your Customer)
                            </h3>
                           
                            <p>
                       
                                KYC is an acronym for “Know Your Customer”. is a general term for the process used for identification of a customer whenever any individual or Non Individual opens an account with a financial entity. KYC establishes an investor’s identity & address through relevant supporting documents such as prescribed photo id (e.g., PAN card) and address proof. In order to invest in any mutual fund, an investor needs to be KYC compliant. The Securities and Exchange Board of India (SEBI) has prescribed certain requirements under the Prevention of Money Laundering Act 2002 for Financial Institutions and Financial Intermediaries including Mutual Funds to know their Investors.<br></br>
                                All Applicants (including POAs and Guardians) are required to be KYC compliant irrespective of the amount of investment. Investors who are not KYC/KRA certified, please fill in the KYC form (individual or Non-Individual).<br></br>
                                A KYC acknowledgement letter should be submitted along with application for opening a folio or making aninvestment. Each holder in the folio must be KYC compliant.<br></br>
                                Investors may kindly note that new SEBI Circular issued regarding uniformity in theKYC process was effective from January 1, 2012.<br></br>
                                <br></br>
                                <p>
                                    1.	SEBI has introduced a common KYC Application Form for all the SEBI registered intermediaries, new Investors are therefore requested to use the common KYC Application Form and carry out the KYC process including In-PersonVerification (IPV) with any SEBI registered intermediaries including mutual funds. The KYC Application Forms are available on our website <a href=" www.jmfinancialmf.com">www.jmfinancialmf.com</a>

                                </p>
                                <p>
                                    2.	The Mutual Fund shall perform the initial KYC for new investors and shall also accept the details change from the investors who have done their KYC prior to 31.12.2011.
                                </p>
                                <p>
                                    3.	It is mandatory to carry out In-Person Verification(IPV) for processing the KYC of its new / existing investors from 01.01.2012.
                                </p>
                                <p>
                                    4.	Once the KYC and IPV-In Person Verification has been done with any SEBI registered intermediary, the investor need not undergo the same process again with any another intermediary including mutual funds. However, the Mutual Fund reserves the right to carry out fresh KYC/additional KYC of the investor.
                                </p>
                                <p>
                                    5.	Existing KYC compliant investors of the Mutual Fund can continue to invest as per the current practice.
                                </p>
                                <p>
                                    6.	Non-individual investors will have to do a fresh KYC due to significant changes in KYC requirements.

                                </p>
                                <p>
                                    7.	In accordance with SEBI Circular No. CIR/MIRSD/13/2013 dated December 26, 2013, the additional details viz. Occupation details, Gross Annual Income/networth and Politically Exposed Person (PEP)* status mentioned under section 2 & 3 which was forming part of uniform KYC form will now be captured in the application form of the Fund. Also, the detail of nature of services viz. Foreign Exchange/Gaming/Money Lending, etc.,(applicable for first/sole applicant) is required to be provided as part of Client Due Diligence (CDD) Process of the Fund.
                                </p>
                                <p>
                                    8.	The said details are mandatory for both Individual and Non Individual applicants. *PEP are defined as individuals who are or have been entrusted with prominent public functions in a foreign country, e.g., Heads of States or of Governments, senior politicians, seniorGovernment/judicial/ military officers, senior executives of state owned corporations, important political party officials, etc. Subsequently, SEBI, vide its circular no. MIRSD/Cir-5/2012 dated April 13, 2012 advised various intermediaries to upload KYC data of its existing customers into the KRA system. While uploading KYC data into the KRA system,intermediaries were also required to highlight such ‘Missing/Not Available’ KYC information of a customer, which was either not required or not taken previously, but was mandatory as per uniform KYC guidelines issued by SEBI.
                                </p>
                                <p>
                                    9.	In accordance with AMFI circular - 35P/MEM-COR/54/2019-20 dated February 28, 2020, it is mandatory, KYC to be verified by KYC Registration Agency before processing redemption. Further, investor requested to complete KYC process before placing redemption request.
                                </p>
                                <p>
                                    10.	In accordance with AMFI Best practices guidelines circular no. 62/2015-16 dated September 18, 2015, investors may note the following:It is mandatory for all new/existing investors to provide additional KYC information such as Income details, Occupation, association with politically exposed person, net worth etc. as mentioned in the application form. Subscription requests, without providing these details, are liable to be rejected.
                                </p>
                                <p>
                                    11.	No subscriptions (whether fresh or additional) and switches pertaining to ‘KYC on-hold’ cases are accepted, unless the investor / unitholder also submits relevant KYC missing / updated information, which is appropriately updated on the KRA - KYC.
                                </p>
                                <p>
                                    12.	Further, it is mandatory for existing customers to complete In-Person Verification process and provide the missing KYC information failing which their applications / transaction requests for additional subscription (including switches) are liable to be rejected.
                                </p>
                                <p><b>Operationalisation of Central KYC Records Registry (CKYCR)</b></p>
                                <p>
                                    Central Registry of Securitisation and Asset Reconstruction and Security interest of India (‘CERSAI’) has been authorised by Government of India to act as Central KYC Records Registry under Prevention of Money-Laundering (Maintenance of Records) Rules, 2005 (‘PMLA Rules’).
                                </p>
                                <p>
                                    SEBI vide its circular ref. no. CIR/MIRSD/66/2016 dated July 21, 2016 and circular ref. no. CIR/MIRSD/120/2016 dated November 10, 2016 has prescribed that the Mutual Fund/ AMC should capture KYC information for sharing with CKYCR as perthe KYC template prescribed by CERSAI for uniform and smooth implementation of CKYC norms for onboarding of new investors in mutual funds.
                                </p>
                                <p>
                                    In accordance with the aforesaid SEBI circulars and AMFI best practice guide lines for implementation of CKYC norms with effect from February 1, 2017:
                                </p>
                                a) lnvestors who have never done KYC process under KRA regime i.e. a new investor who is new to KRA system and whose KYC is not registered orveri fied in the KRA system shall be required to provide KYC details in the CKYCForm to the Mutual Fund/ AMC.
                                <br></br>
                                b) Investors who fills old KRA KYC Form, should provide additional /missing information using Supplementary KYC Form or fill CKYC Form.
                                <br></br>
                                c) Details of investors shall be uploaded on the system of CKYCR and a 14 digit unique KYC identifier (‘KIN’) will be generated for such customer.
                                <br></br>

                                d) New investors, who have completed CKYC process & have obtained KIN may quote their KIN in the application form instead of submitting CKYC Form/Supplementary KYC Form.
                                <br></br>
                                e) AMC/ Mutual Fund shall use the KIN of the investor to download the KYC information from CKYCR system and update its records.
                                <br></br>
                                f) If the PAN of investor is not updated on CKYCR system, the investor should submit self-certified copy of PAN card to the Mutual Fund/ AMC.
                                <p>
                                    The CKYC Form and Supplementary KYC Form are available at Investor Service Centre (ISC) of JM Financial Mutual Fund and on website <a href="www.jmfinancialmf.com.">www.jmfinancialmf.com.</a> The AMC reserves the right to reject transaction application in case the investor(s)fails to submit information and/or documentation as mentioned above. In the event of non-compliance of KYC requirements, the Trustee / AMC reserves the right to freeze the folio of the investor(s).
                                </p>
                            </p>
                        </div>
                    </ Col>
                </Row>
            </Container>
            <div className="container-fluid account-opning-container">
                <div className="container">
                    <div className="heading">
                        The following SEBI registered intermediaries are required to carry out a uniform KYC process at the
                        time of account opening:
                    </div>
                    <div className="row">
                        <div className="col-lg-2 col-md-4 kyc-process">
                            Stock Brokers
                        </div>
                        <div className="col-lg-2 col-md-4 kyc-process">
                            Depository Participants (DPs)
                        </div>
                        <div className="col-lg-2 col-md-4 kyc-process">
                            Mutual Funds (MFs) or Registrar and Transfer agents (RTA) on their behalf.
                        </div>
                        <div className="col-lg-2 col-md-4 kyc-process">
                            Portfolio Managers (PMs)
                        </div>
                        <div className="col-lg-2 col-md-4 kyc-process">
                            Venture Capital Funds (VCFs)
                        </div>
                        <div className="col-lg-2 col-md-4 kyc-process">
                            Collective Investment Schemes (CIS)
                        </div>
                    </div>
                </div>
            </div>
            <section className="sectionKyc">
                <Container>
                    <Row>
                        <Col>
                        
                            {data && data.length > 0 ? (
                                <>
                                    {data &&
                                        data.map(
                                            ({ heading, description }) => (
                                                <Accordion className="accordionFinQ">
                                                    <Accordion.Item eventKey="0">
                                                        <Accordion.Header >
                                                            {heading}
                                                        </Accordion.Header>
                                                        <Accordion.Body className="textjustify">
                                                            {description}
                                                        </Accordion.Body>
                                                    </Accordion.Item>
                                                </Accordion>
                                            ))}
                                </>
                            ) : (
                                <h5 className="errormsgComNew">No Data Found !!!</h5>
                            )}
                            {loadingshow ? <div className="textcentervertex">
                               
                                <img src={animation} alt="Loading" />
                                <div className="model_popup">Please Wait...</div>
                            </div> : ""
                            }
                        </Col>
                    </Row>
                </Container>
            </section>
            <Container>
                <Row>
                    <Col sm={12}>
                        <p className="one-time-para">
                            KYC is one time exercise while dealing in securities markets - once KYC is done through a SEBI
                            registered intermediary (broker, DP, Mutual Fund etc), you need not undergo the same process again when
                            you approach another intermediary.
                        </p>
                        <div className="kyc-btn-container">
                            <p>Downloads:</p>
                            <button className="button"><a href={KYCIndividual} target="_blank">KYC Individual</a></button>
                            <button className="button"><a href={KYCNonIndividual} target="_blank">KYC Non-Individual</a></button>
                        </div>
                        
                    </Col>
                </Row >
            </Container > */}
        </>
    );
}

export default FinQKYC;